<template>
  <AttributesTable
    :attributes="editableCompany.attributes"
    :editableAttributeOrigin="editableAttributeOrigin"
    @addNewAttribute="addNewAttribute"
    @saveAttribute="saveAttribute"
    @deleteAttribute="deleteAttribute">
  </AttributesTable>
</template>

<script>
import AttributesTable from "../../Shared/AttributesTable";
import { AttributeOrigin } from "../../../models/AttributeOrigin";
import _ from "lodash";

export default {
    components: { AttributesTable },
    props: {
        company: {
            type: Object,
            default: function() {
                return null;
            }
        },
        isOpen: Boolean
    },
    data() {
        return {
            editableCompany: _.cloneDeep(this.company),
            editableAttributeOrigin: AttributeOrigin.RG
        };
    },
    watch: {
        company(val) {
            this.editableCompany = (!val) ? {} : _.cloneDeep(val);
        }
    },
    methods: {
        addNewAttribute: function(newAttribute, eventTargetId) {
            this.$emit("addNewAttribute", newAttribute, eventTargetId);
        },
        saveAttribute: function(attribute, eventTargetId) {
            this.$emit("saveAttribute", attribute, eventTargetId);
        },
        deleteAttribute: function(attribute, eventTargetId) {
            this.$emit("deleteAttribute", attribute, eventTargetId);
        }
    }
};
</script>
